/*
  2026 navigation, desktop panels (snippets/nav-v2.liquid).

  - Pointer: hovering a bar item opens its panel after a short delay; leaving the
    bar and panel closes it. Bar items stay real links, so a click navigates.
  - Touch at desktop widths (e.g. a tablet in landscape): the first tap on an
    item with a panel opens it, a second tap follows the link.
  - Keyboard: focusing a bar item opens its panel; Escape closes it and returns
    focus to the item; tabbing out of the nav closes it.
*/
if (!customElements.get('nav-v2-menu')) {
  customElements.define(
    'nav-v2-menu',
    class NavV2Menu extends HTMLElement {
      connectedCallback() {
        // data-nav-panel, not aria-controls: wambody.liquid strips aria-controls from links.
        this.triggers = [...this.querySelectorAll('.nav-v2__trigger[data-nav-panel]')];
        this.openTimer = null;
        this.closeTimer = null;
        this.current = null;

        this.triggers.forEach((trigger) => {
          const item = trigger.closest('.nav-v2__item');
          item.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'touch') return;
            this.schedule(() => this.open(trigger), this.current ? 0 : 120);
          });
          trigger.addEventListener('click', (event) => {
            if (this.lastPointer === 'touch' && this.current !== trigger) {
              event.preventDefault();
              this.open(trigger);
            }
          });
          trigger.addEventListener('pointerdown', (event) => {
            this.lastPointer = event.pointerType;
          });
          trigger.addEventListener('focus', () => this.open(trigger));
        });

        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch') return;
          this.schedule(() => this.close(), 150);
        });
        this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer));
        this.addEventListener('keyup', (event) => {
          if (event.code !== 'Escape' || !this.current) return;
          const trigger = this.current;
          this.close();
          trigger.focus({ preventScroll: true });
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });
        document.addEventListener('click', (event) => {
          if (this.current && !this.contains(event.target)) this.close();
        });
      }

      schedule(fn, delay) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        if (delay) {
          this.openTimer = setTimeout(fn, delay);
        } else {
          fn();
        }
      }

      open(trigger) {
        if (this.current === trigger) return;
        this.close(true);
        const panel = document.getElementById(trigger.dataset.navPanel);
        if (!panel) return;
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        this.current = trigger;
        this.classList.add('nav-v2__bar--open');
      }

      close(switching = false) {
        clearTimeout(this.openTimer);
        if (!this.current) return;
        const panel = document.getElementById(this.current.dataset.navPanel);
        if (panel) panel.hidden = true;
        this.current.setAttribute('aria-expanded', 'false');
        this.current = null;
        if (!switching) this.classList.remove('nav-v2__bar--open');
      }
    }
  );
}

/*
  Mobile drawer close (snippets/nav-v2-drawer.liquid). The full-screen drawer covers
  the header's own toggle, so its top bar has a close control that hands off to the
  theme's MenuDrawer (scroll unlock, focus return to the toggle).
*/
document.addEventListener('click', (event) => {
  const close = event.target.closest('[data-nav-drawer-close]');
  if (!close) return;
  event.preventDefault();
  const drawer = close.closest('header-drawer');
  const toggle = drawer && drawer.querySelector('summary');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event, toggle);
  }
});
